import { PaintedScene } from '../PaintedScene';

export const EMBER_SHRINE_PHASER_KEY = 'EmberShrineScene' as const;
export const EMBER_SHRINE_MANIFEST_KEY = 's-403-ember-shrine' as const;

export class EmberShrineScene extends PaintedScene {
  constructor() {
    super(EMBER_SHRINE_PHASER_KEY, EMBER_SHRINE_MANIFEST_KEY);
  }
}
